import { PAGE_NM } from '../../types/types';

export const HOME_TABS = [
  { label: '신용대출', value: PAGE_NM.HOME },
  { label: '주택담보', value: PAGE_NM.MTG_HOME },
] as const;
